import { generateUtilityClasses } from '@mui/material';

export const buttonGhostClasses = generateUtilityClasses('ButtonGhost', ['root', 'label']);

// ButtonGhost의 styleOverrides와 defaultProps는 컴포넌트 내부로 이전됨
// Module augmentation도 제거 (useThemeProps를 사용하지 않으므로 불필요)
